import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import axios from 'axios';

// api config
const api = axios.create({
  baseURL: '/api/v1/',
});
api.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const numbers = "0123456789";
const lowercase = "abcdefghijklmnopqrstuvwxyz";
const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const specialchars = "~!@#$%^&*()_+*/=";

// id必须唯一
const HeadTabs = [
  { id: 'cipher', name: '加密解密' },
  { id: 'format', name: '格式转换' },
  { id: 'gpt', name: 'GPT' },
]

const CipherSideBarMenu = [
  {
    group: { id: "Symmetric encryption", name: "对称加密算法" },
    menus: [
      { id: "DES", name: "DES" },
      { id: "AES", name: "AES" },
    ]
  },
  {
    group: { id: "Asymmetric encryption", name: "非对称加密算法" },
    menus: [
      { id: "RSA", name: "RSA" },
    ]
  },
  {
    group: { id: "other", name: "其他" },
    menus: [
      { id: "RandomCipher", name: "随机密码" },
    ]
  }
]

const FormatSideBarMenu = [
  {
    group: { id: "format", name: "格式转换" },
    menus: [
      { id: "Timestamp", name: "时间戳转换" },
      { id: "Json", name: "JSON格式化" },
      { id: "Base64", name: "Base64" },
      { id: "NumberConversion", name: "进制转换" },
    ]
  },
  {
    group: { id: "other_format", name: "其他" },
    menus: [
      { id: "Jsfuck", name: "JSFUCK", redirect: "http://www.jsfuck.com/" },
      { id: "Jskaomoji", name: "JS颜文字", redirect: "http://utf-8.jp/public/aaencode.html" },
    ]
  }
]

const GPTSideBarMenu = [
  {
    group: { id: "format", name: "GPT" },
    menus: [
      { id: "GPT35Turbo", name: "GPT-3.5 Turbo", iframe: "https://chatgpt.sha256.cc/" },
    ]
  }
]

const SiderBarMenus = {
  index: { menu: [], default: "" },
  cipher: { menu: CipherSideBarMenu, default: "AES" },
  format: { menu: FormatSideBarMenu, default: "Timestamp" },
  gpt: { menu: GPTSideBarMenu, default: "GPT35Turbo" }
}

function registerComponents(components) {
  const requireComponent = require.context(
    // 其组件目录的相对路径
    '@/components',
    // 是否查询其子目录
    true,
    // 匹配基础组件文件名的正则表达式
    /\w+\.(vue|js)$/
  )

  requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)
    // 获取组件的 PascalCase 命名
    const componentName = upperFirst(
      camelCase(
        // 剥去文件名开头的 `./` 和结尾的扩展名
        fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
      )
    )
    components[componentName] = componentConfig.default || componentConfig;
  })
}

export {
  HeadTabs, SiderBarMenus, numbers, lowercase, uppercase, specialchars, registerComponents, api
}
